export const getIdFromDataAttribute = event =>
	Number.parseInt(event.currentTarget.getAttribute('data-id'))
